module.exports = __webpack_public_path__ + "static/media/Comportamiento_Fraudulento_Centro_de_Pruebas.59d6ac04.docx";